import type { SelectOptionType } from "~/core/types/common.type";

export interface FormOptionType extends Omit<SelectOptionType, "order"> {
  option_id: string;
  field_id: string;
  order_in_field?: number;
}

export interface InputTypeMetaData {
  type: InputTypeEnum;
  label: string;
  options?: FormOptionType[];
  placeholder?: string;
  required?: boolean;
  order_in_form?: number;
  previousType?: InputTypeEnum;
}

export interface FormMap {
  [key: string]: InputTypeMetaData;
}

export interface IField {
  field_type: string;
  label: string;
  required: boolean;
  placeholder: string;
  order_in_form: number;
  options?: string[];
}

export interface IFormBody {
  name: string;
  description: string;
  link: string;
  fields?: IField[];
  formId?: string;
}

export enum InputTypeEnum {
  Text = "text",
  LongText = "long_text",
  Select = "select",
  Paragraph = "paragraph",
  Number = "number",
  Email = "email",
  Radio = "radio",
  MultiSelect = "multi_select",
}

export enum InputLabelEnum {
  Text = "Short text",
  LongText = "Long text",
  Select = "Dropdown",
  Paragraph = "Paragraph",
  Number = "Numeric",
  Email = "Email",
  Radio = "Radio",
  MultiSelect = "Multiple choice",
}

export class InvalidInputTypeError extends Error {
  constructor(type: string) {
    super(`Invalid input type: ${type}`);
    this.name = "InvalidInputTypeError";
    this.message = `Invalid input type: ${type}`;
  }
}

export enum PreviewDevice {
  MOBILE = "mobile",
  DESKTOP = "desktop",
}

export enum EditableField {
  Title = "title",
  Description = "description",
}
